module.exports = __webpack_public_path__ + "static/media/contacts-off.75c7e6e0.svg";